var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66659 7.58332H9.33325V6.41666H4.66659V7.58332ZM4.66659 9.33332H9.33325V8.16666H4.66659V9.33332ZM4.66659 11.0833H7.58325V9.91666H4.66659V11.0833ZM3.49992 12.8333C3.17909 12.8333 2.90443 12.7191 2.67596 12.4906C2.44749 12.2621 2.33325 11.9875 2.33325 11.6667V2.33332C2.33325 2.01249 2.44749 1.73784 2.67596 1.50936C2.90443 1.28089 3.17909 1.16666 3.49992 1.16666H8.16658L11.6666 4.66666V11.6667C11.6666 11.9875 11.5523 12.2621 11.3239 12.4906C11.0954 12.7191 10.8208 12.8333 10.4999 12.8333H3.49992ZM7.58325 5.24999V2.33332H3.49992V11.6667H10.4999V5.24999H7.58325Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.2430dde681747b2f31f5f0d973a64f82.svg";
export { ForwardRef as ReactComponent };